<script setup lang="ts">
    import { computed } from 'vue';
    import HipSpineDetectionCard from './HipSpineDetectionCard.vue';
    import HipSpineRecommendationCard from './HipSpineRecommendationCard.vue';
    import type { HipSpineClassification } from '@/domain/anatomy/pelvis/hipSpineClassification';
    import {
        flatbackThresholdText,
        pptThresholdText,
        stiffWarningContent,
    } from '@/domain/anatomy/pelvis/hipSpineThresholdText';

    const props = defineProps<{ classification: HipSpineClassification }>();

    const stiffCard = computed(() => stiffWarningContent(props.classification));
    const showRecommendation = computed(() => props.classification.recommendations.length > 0);
</script>

<template>
    <div class="hip-spine-warnings d-flex flex-column ga-2 mt-3" data-testid="hip-spine-warnings">
        <hip-spine-detection-card
            label="Flatback Deformity"
            :detected="classification.flatback"
            :threshold-text="flatbackThresholdText(classification.flatback)"
        />
        <hip-spine-detection-card
            v-if="stiffCard"
            label="Stiff Spine"
            :detected="stiffCard.detected"
            :threshold-text="stiffCard.thresholdText"
        />
        <hip-spine-detection-card
            label="Posterior Pelvic Tilt"
            :detected="classification.ppt"
            :threshold-text="pptThresholdText(classification.ppt)"
        />
        <hip-spine-recommendation-card
            v-if="showRecommendation"
            :recommendations="classification.recommendations"
        />
    </div>
</template>
